<template>
  <div>
    <div style="display: flex; align-items: center;">
      <q-input
        outlined
        clearable
        v-model="searchText"
        :label="getSearchRadioButton(selection).searchRadioButtonLabel"
        v-on:keyup.enter="submitSingularSearch()"
        v-if="selection != 'report_date' && dropdownOptions == null"
        style="flex-grow: 3"
      />
      <q-select
        outlined
        v-model="searchText"
        bottom-slots
        use-input
        hide-selected
        fill-input
        clearable
        input-debounce="0"
        :options="dropdownOptions.value"
        @filter="dropdownFilter"
        :label="getSearchRadioButton(selection).searchRadioButtonLabel"
        v-on:keyup.enter="submitSingularSearch()"
        v-if="dropdownOptions != null"
        style="flex-grow: 3"
      >
        <template v-slot:hint>
          <a v-if="selection == 'location_id'" @click="CommonHelper.openURLToNewTab('./Historical School Names for Assets List.pdf')" href="./Historical School Names for Assets List.pdf">School Name History</a>
        </template>
      </q-select>
      <q-input
        outlined
        v-model="modelReportDateBegin"
        clearable
        label="Begin"
        v-if="selection == 'report_date'"
        mask="##-##-####"
        hint="MM-DD-YYYY"
        :rules="[(val) => val === null || val === '' || CommonHelper.isValidDate(val)]"
      >
        <template v-slot:append>
          <q-icon name="event" class="cursor-pointer">
            <q-popup-proxy transition-show="scale" transition-hide="scale">
              <q-date v-model="modelReportDateBegin" mask="MM-DD-YYYY" minimal>
                <div class="row justify-end">
                  <q-btn v-close-popup label="Close" color="primary" flat />
                </div>
              </q-date>
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
      <q-input
        outlined
        v-model="modelReportDateEnd"
        clearable
        label="End"
        v-if="selection == 'report_date'"
        mask="##-##-####"
        hint="MM-DD-YYYY"
        :rules="[(val) => val === null || val === '' || CommonHelper.isValidDate(val)]"
      >
        <template v-slot:append>
          <q-icon name="event" class="cursor-pointer">
            <q-popup-proxy transition-show="scale" transition-hide="scale">
              <q-date v-model="modelReportDateEnd" mask="MM-DD-YYYY" minimal>
                <div class="row justify-end">
                  <q-btn v-close-popup label="Close" color="primary" flat />
                </div>
              </q-date>
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>

      <q-btn
        unelevated
        round
        icon="close"
        class="circle-btn"
        text-color="white"
        style="background: #8c8c8c; margin-left: 12px;"
        @click.stop="CommonHelper.cancelSearch()"
        v-if="CommonHelper.displayCancelBtn.value"
      />

      <q-btn
        unelevated
        round
        icon="search"
        class="circle-btn"
        title="Search"
        aria-label="Search"
        text-color="white"
        style="background: #0067c1; margin-left: 12px;"
        @click.stop="submitSingularSearch()"
        :disabled="CommonHelper.loadingInitialSearchResults.value"
      />
    </div>
    <div class="q-px-md">
      <div>
        <ul
          style="
            list-style-type: none;
            padding: 0;
            margin-left: 20px;
            display: flex;
          "
        >
          <div>
            <li v-for="searchRadioButton in searchRadioButtons[0]" :key="searchRadioButton">
              <q-radio v-model="selection" :val="searchRadioButton.searchRadioButtonVal" :label="searchRadioButton.searchRadioButtonLabel" />
            </li>
          </div>
          <div>
            <li v-for="searchRadioButton in searchRadioButtons[1]" :key="searchRadioButton">
              <q-radio v-model="selection" :val="searchRadioButton.searchRadioButtonVal" :label="searchRadioButton.searchRadioButtonLabel" />
            </li>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import LocSchoolMap from "../../assets/CPT-Map-LOC-School.json";
import CommonHelper from "../helper/CommonHelper.js";

export default {
  name: "SingularSearchContainer",
  props: {
    scopeFields: Array
  },
  setup(props) {
    const selection = ref("label");
    const searchText = ref(null);
    const modelReportDateBegin = ref(null);
    const modelReportDateEnd = ref(null);

    const searchRadioButtons = computed(() => {
      var searchRadioButtonsArray = [];
      searchRadioButtonsArray[0] = [];
      searchRadioButtonsArray[1] = [];

      var filteredScopeFields = props.scopeFields.filter((scopeField) => {
        return scopeField !== "date" && scopeField !== "location" && scopeField !== "scope";
      });

      var indexSeparator = filteredScopeFields.length > 5 ? Math.ceil(filteredScopeFields.length / 2) : filteredScopeFields.length;

      filteredScopeFields.forEach((scopeField, scopeFieldIndex) => {
        var outerIndex = scopeFieldIndex >= indexSeparator ? 1 : 0;
        var innerIndex = scopeFieldIndex >= indexSeparator ? scopeFieldIndex - indexSeparator : scopeFieldIndex;

        searchRadioButtonsArray[outerIndex][innerIndex] = getSearchRadioButton(scopeField);
      });

      return searchRadioButtonsArray;
    });

    /*
     * Returns a searchRadioButton from the given parameters
     */
    function getSearchRadioButton(scopeField) {
      var searchRadioButtonLabel = "";

      switch (scopeField) {
        case "action_category":
          searchRadioButtonLabel = "Category";
          break;
        case "company_name":
          searchRadioButtonLabel = "Company Name";
          break;
        case "delivery_party":
          searchRadioButtonLabel = "Delivery Party";
          break;
        case "description":
          searchRadioButtonLabel = "Description";
          break;
        case "document_category":
          searchRadioButtonLabel = "Document Category";
          break;
        case "file_type":
          searchRadioButtonLabel = "Type";
          break;
        case "file_year":
          searchRadioButtonLabel = "Year";
          break;
        case "invoice_number":
          searchRadioButtonLabel = "Invoice Number";
          break;
        case "island":
          searchRadioButtonLabel = "Island";
          break;
        case "job_number":
          searchRadioButtonLabel = "Job Number";
          break;
        case "label":
          searchRadioButtonLabel = "Document Name";
          break;
        case "location_id":
          searchRadioButtonLabel = "School Name";
          break;
        case "project_number":
          searchRadioButtonLabel = "Project Number";
          break;
        case "purchase_order_number":
          searchRadioButtonLabel = "Purchase Order Number";
          break;
        case "purchase_order_originator":
          searchRadioButtonLabel = "Purchase Order Originator";
          break;
        case "report_date":
          searchRadioButtonLabel = "Report Date";
          break;
        case "service_contract_type":
          searchRadioButtonLabel = "Service Contract Type";
          break;
        case "vendor_or_supplier":
          searchRadioButtonLabel = "Vendor or Supplier";
          break;
        case "work_order_number":
          searchRadioButtonLabel = "Work Order Number";
          break;
      }

      var searchRadioButton =
        {
          searchRadioButtonVal: scopeField,
          searchRadioButtonLabel: searchRadioButtonLabel
        };

      return searchRadioButton;
    }

    watch(searchRadioButtons, () => {
      // reset selection to "Document Name" if selected value no longer exists in searchRadioButtons
      var searchRadioButton1 = searchRadioButtons.value[0].findIndex((searchRadioButton) => {
        return searchRadioButton.searchRadioButtonVal === selection.value;
      });

      var searchRadioButton2 = searchRadioButtons.value[1].findIndex((searchRadioButton) => {
        return searchRadioButton.searchRadioButtonVal === selection.value;
      });

      if (searchRadioButton1 < 0 && searchRadioButton2 < 0) {
        selection.value = "label";
      }
    });

    const dropdownOptions = computed(() => {
      let returnValue = null;

      switch(selection.value) {
        case "action_category":
          returnValue = CommonHelper.actionCategoryOptions;
          break;
        case "company_name":
          returnValue = CommonHelper.companyNameOptions;
          break;
        case "document_category":
          returnValue = CommonHelper.documentCategoryOptions;
          break;
        case "file_type":
          returnValue = CommonHelper.fileTypeOptions;
          break;
        case "island":
          returnValue = CommonHelper.islandOptions;
          break;
        case "location_id":
          returnValue = CommonHelper.schoolOptions;
          break;
        case "service_contract_type":
          returnValue = CommonHelper.serviceContractTypeOptions;
          break;
      }

      return returnValue;
    });

    const dropdownFilter = computed(() => {
      let returnValue = null;

      switch(selection.value) {
        case "action_category":
          returnValue = CommonHelper.filterActionCategory;
          break;
        case "company_name":
          returnValue = CommonHelper.filterCompanyName;
          break;
        case "document_category":
          returnValue = CommonHelper.filterDocumentCategory;
          break;
        case "file_type":
          returnValue = CommonHelper.filterFileType;
          break;
        case "island":
          returnValue = CommonHelper.filterIsland;
          break;
        case "location_id":
          returnValue = CommonHelper.filterSchool;
          break;
        case "service_contract_type":
          returnValue = CommonHelper.filterServiceContractType;
          break;
      }

      return returnValue;
    });

    watch(dropdownOptions, () => {
      checkSearchText();
    });

    watch(
      () => CommonHelper.selectedSearchScopeOptions.value,
      () => {
        if (selection.value === "file_type") {
          checkSearchText();
        }
      },
      { deep: true, immediate: true }
    );

    function checkSearchText() {
      if (dropdownOptions.value === null || !dropdownOptions.value.value.includes(searchText.value)) {
        searchText.value = null;
      }
    }

    function submitSingularSearch() {
      if (!CommonHelper.loadingInitialSearchResults.value) {
        let queryArray = [];

        if (selection.value === "report_date") {
          if (modelReportDateBegin.value !== null && modelReportDateBegin.value !== "") {
            queryArray.push(
              {
                searchText: modelReportDateBegin.value,
                searchAttribute: { value: "report_date_begin" }
              }
            );
          }

          if (modelReportDateEnd.value !== null && modelReportDateEnd.value !== "") {
            queryArray.push(
              {
                searchText: modelReportDateEnd.value,
                searchAttribute: { value: "report_date_end" }
              }
            );
          }
        } else {
          queryArray.push(
            {
              searchText: searchText.value,
              searchAttribute: { value: selection.value }
            }
          );
        }

        CommonHelper.submitSearch(queryArray);
      }
    }

    const runQuerySingularSearch = computed(() => {
      return CommonHelper.firestoreTableInput.value === null && CommonHelper.indexCounts.value !== null && CommonHelper.loadingQuerySearch.value &&
        CommonHelper.selectedSearchScopeOptions.value.length > 0 && CommonHelper.querySearchType.value.includes("singular");
    });

    watch(runQuerySingularSearch, () => {
      if (runQuerySingularSearch.value) {
        selection.value = Object.keys(CommonHelper.querySearchParameters.value)[0];
        searchText.value = CommonHelper.querySearchParameters.value[selection.value];

        switch(selection.value) {
            case "location_id":
              searchText.value = LocSchoolMap[searchText.value];
              break;
            case "report_date_begin":
              modelReportDateBegin.value = searchText.value;
              searchText.value = "";
              selection.value = "report_date";
              break;
            case "report_date_end":
              modelReportDateEnd.value = searchText.value;
              searchText.value = "";
              selection.value = "report_date";
              break;
        }
      
        submitSingularSearch();
      }
    })

    return {
      //variable properties
      selection,
      searchText,
      modelReportDateBegin,
      modelReportDateEnd,
      searchRadioButtons,
      dropdownOptions,
      dropdownFilter,

      //functions
      getSearchRadioButton,
      submitSingularSearch,

      //helpers
      CommonHelper
    };
  },
};
</script>

<style lang="scss" scoped>
.q-pa-md {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
